import { Variants } from '~/components/ui/Button.vue'
import { ActionFields, ActionReferencePanel, Type } from './Action.vue'

export function actionTransformer(attrs: ActionFields | undefined) {
  const supportingData = attrs?.fields?.supportingData?.home

  const type = attrs?.sys?.contentType?.sys?.type as Type
  const variant = supportingData?.variant?.value as Variants
  const { url, text, icon } = attrs?.fields || {}
  const newTab = supportingData?.newTab?.value
  return type === 'Link' ? { type, variant, text, icon, url, newTab } : { type, variant, text }
}

export function actionModalTransformer(attrs: ActionFields | undefined) {
  const supportingData = attrs?.fields?.supportingData?.home
  const variant = supportingData?.clickOperation?.value || 'popup'
  const action = supportingData?.action?.value
  const innerPanel: ActionReferencePanel | undefined = attrs?.fields?.references?.[0] ?? attrs?.references?.[0]
  const isProductList = innerPanel?.sys?.contentType?.sys?.id === 'productCarousel' && variant === 'slide'
  const isRTPModal = innerPanel?.sys?.contentType?.sys?.id === 'richTextPanel' && ['popup', 'slide'].includes(variant)

  return { variant, action, innerPanel, isProductList, isRTPModal }
}

export function actionRenderGuards(attrs: (ActionFields & { sfccPromotion?: boolean }) | undefined) {
  const isBlank = !attrs || !Object.keys(attrs).length
  const isButton = attrs?.fields?.type === 'Button'
  const isSfccPromotion = !!attrs?.sfccPromotion
  const { isProductList, isRTPModal } = actionModalTransformer(attrs)

  return { isBlank, isButton, isSfccPromotion, isProductList, isRTPModal }
}

export type { ActionFields }
